import { render, staticRenderFns } from "./Accordion.vue?vue&type=template&id=df9b891c&scoped=true&"
import script from "./Accordion.vue?vue&type=script&lang=js&"
export * from "./Accordion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df9b891c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('df9b891c')) {
      api.createRecord('df9b891c', component.options)
    } else {
      api.reload('df9b891c', component.options)
    }
    module.hot.accept("./Accordion.vue?vue&type=template&id=df9b891c&scoped=true&", function () {
      api.rerender('df9b891c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2wMcPJoPmJQrS/JS/comp/Accordion.vue"
export default component.exports